import React, { useState } from 'react';
import CustomContainer from '../../components/CustomContainer';
import Loader from '../../components/loader/Loader';
import { useNavigate, useParams } from 'react-router-dom';
import FunctionalTableComponent from '../../components/table/FunctionalTableComponent';
import columns from './PriceListTableConfig';
import IconButton from '../../components/button/IconButton';
import { Button } from 'react-bootstrap';
import LightButton from '../../components/button/LightButton';

const PriceListsPage = (props) => {
  const [loader, setLoader] = useState(false);
  const [reload, setReload] = useState(false);

  const navigate = useNavigate();

  return (
    <>
      <Loader loader={loader} />
      <CustomContainer title={'Cenniki'}>
        <FunctionalTableComponent
          shadow={false}
          title={'Lista cenników'}
          columns={columns}
          header={true}
          api={'price-list'}
          setLoader={setLoader}
          removable={true}
          trick="Tutaj dodajesz nowe cenniki. Aby cennik był aktywny, musisz powiązać go z domkiem na stronie edycji domku. Nie można usunąć cennika przypisanego do domku."

          deleteModalTitle={'Usunięcie cennika'}
          deleteModalDescription={'Czy na pewno chcesz usunąć cennik?'}
          editable={false}
          customCreate={() => navigate('/price-list')}
          details={true}
          detailsAction={(id) => navigate('/price-list/' + id)}
          width={12}
        />
      </CustomContainer>
    </>
  );
};

export default PriceListsPage;
